import { createStore } from 'vuex'
import VuexPersistence from 'vuex-persist';

import api from '@/api';
// Vuex.Store.prototype.axios = api;

import Ui from './modules/Ui';
import Auth from './modules/Auth';
import User from './modules/User';
import Streams from './modules/Streams';
import Regions from './modules/Regions';
import PlatformUsage from './modules/PlatformUsage';
import StreamCache from './modules/StreamCache';
import DynamicPlayers from './modules/DynamicPlayers';
import Playout from './modules/Playout';
import Playlist from './modules/Playlist';
import Showcase from './modules/Showcase';
import Highlight from './modules/Highlight';
import Transcoders from './modules/Transcoders';
import Mediaflows from './modules/Mediaflows';
import Paywalls from './modules/Paywalls';
import Destination from './modules/Destination';
import Multiview from './modules/Multiview';
import Projects from './modules/Projects';
import Sites from './modules/Sites';

const vuexStorage = new VuexPersistence({
	storage: window.localStorage,
	supportCircular: false,
	// Save only these modules:
	reducer: (state) => ({
		Ui: state.Ui,
		Auth: state.Auth
	})
});

const defaultState = () => ({
	modal: null,
	isLoading: false,
});

const state = defaultState();

const mutations = {
	SET_MODAL(state, modalName) {
		state.modal = modalName;
	},
	SET_LOADING(state, isLoading) {
		state.isLoading = isLoading;
	}
};

const actions = {
	setModal({ commit }, modalName) {
		commit('SET_MODAL', modalName);
	},
	setLoading({ commit }, isLoading) {
		commit('SET_LOADING', isLoading);
	}
};

export default createStore({
	state,
	mutations,
	actions,
	modules: {
		Ui,
		Auth,
		User,
		Streams,
		Regions,
		PlatformUsage,
		StreamCache,
		DynamicPlayers,
		Playout,
		Highlight,
		Playlist,
		Showcase,
		Transcoders,
		Mediaflows,
		Paywalls,
		Destination,
		Multiview,
		Projects,
		Sites
		// accounts,
		// streams
	},
	plugins: [vuexStorage.plugin],
	strict: process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'staging'
});
